












import Vue from 'vue'
import iconArrowDown from '@/assets/svg/rounded/arrow-down.svg?inline'
import { DataTableColumnItem } from '@/models/dataTable'
import { ESortDir } from '@/constants/dataTable'

interface Props {
  column: DataTableColumnItem
}
interface Methods {
  setQuery: (direction: ESortDir) => void
  isActive: (direction: ESortDir) => boolean
}

export default Vue.extend<{}, Methods, {}, Props>({
  components: {
    iconArrowDown,
  },
  props: {
    column: {
      required: true,
    },
  },
  data() {
    return {
      directions: Object.values(ESortDir),
    }
  },
  methods: {
    setQuery(direction) {
      this.$router.push({
        query: {
          ...this.$route.query,
          sort: `${this.column.key}:${direction}`,
        },
      })
    },
    isActive(direction) {
      if (this.$route.query.sort) {
        const sort = (this.$route.query.sort as string).split(':')
        return sort[0] === this.column.key && sort[1] === direction
      }
      return false
    },
  },
})
